import { useThemeContext } from '#contexts/ThemeContext';
import { ImageComponent } from '#modules/ImageComponent';
import { Box, makeStyles } from '@material-ui/core';
import Carousel from 'react-material-ui-carousel';

interface ProductImageProps {
  imageUrl: string;
  thumbnailImages: string[];
  setPrimaryImage: (image: string) => void;
}

export const ProductImage = ({ imageUrl, thumbnailImages, setPrimaryImage }: ProductImageProps) => {
  const classes = useStyles();
  const changePrimaryImage = (image: string) => {
    if (imageUrl !== image) {
      setPrimaryImage(image);
    }
  };
  const { iconColor } = useThemeContext();

  return (
    <Box>
      {thumbnailImages?.length > 1 ? (
        <Carousel
          autoPlay
          fullHeightHover={false}
          navButtonsAlwaysInvisible
          timeout={500}
          interval={5000}
          indicatorIconButtonProps={{ style: { width: 'auto', height: 'auto' } }}
        >
          {thumbnailImages.map((image, i) => (
            <Box
              key={i}
              clone
              marginTop={{
                sm: 4.5
              }}
            >
              <ImageComponent src={image} color={iconColor} className={classes.imageCustom} />
            </Box>
          ))}
        </Carousel>
      ) : (
        <Box
          clone
          marginTop={{
            sm: 4.5
          }}
        >
          <ImageComponent src={thumbnailImages[0]} color={iconColor} className={classes.imageCustom} />
        </Box>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme?: any) => {
  return {
    imageCustom: {
      width: '100%',
      display: 'block',
      objectFit: 'contain',
      [theme.breakpoints.down('xl')]: {
        maxWidth: 400,
        height: 400
      },
      [theme.breakpoints.down('lg')]: {
        maxWidth: 334,
        height: 334
      },
      [theme.breakpoints.down('md')]: {
        maxWidth: 264,
        height: 264
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%'
      }
    },
    imageThumailCustom: {
      objectFit: 'contain',
      cursor: 'pointer'
    }
  };
});
